"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 15",
    width: "34",
    height: "15"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M31,11H3c-0.3,0-0.5-0.2-0.5-0.5v-10C2.5,0.2,2.7,0,3,0h28c0.3,0,0.5,0.2,0.5,0.5v10 C31.5,10.8,31.3,11,31,11z M3.5,10h27V1h-27V10z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M33.5,11h-3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5S33.8,11,33.5,11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M3.5,11h-3C0.2,11,0,10.8,0,10.5S0.2,10,0.5,10h3C3.8,10,4,10.2,4,10.5S3.8,11,3.5,11z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "11.4",
    y: "10.6",
    fill: "#EC6833",
    width: "10.7",
    height: "1.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M22.1,12.7H11.4c-0.3,0-0.5-0.2-0.5-0.5v-1.6c0-0.3,0.2-0.5,0.5-0.5h10.7c0.3,0,0.5,0.2,0.5,0.5v1.6 C22.6,12.5,22.3,12.7,22.1,12.7z M11.9,11.7h9.7v-0.6h-9.7V11.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M8,15c-1.4,0-2.5-1.1-2.5-2.5S6.6,10,8,10s2.5,1.1,2.5,2.5S9.4,15,8,15z M8,11c-0.8,0-1.5,0.7-1.5,1.5 S7.2,14,8,14s1.5-0.7,1.5-1.5S8.8,11,8,11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M3.6,15c-1.4,0-2.5-1.1-2.5-2.5S2.2,10,3.6,10s2.5,1.1,2.5,2.5S5,15,3.6,15z M3.6,11 c-0.8,0-1.5,0.7-1.5,1.5S2.8,14,3.6,14s1.5-0.7,1.5-1.5S4.4,11,3.6,11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M29.8,15c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S31.2,15,29.8,15z M29.8,11 c-0.8,0-1.5,0.7-1.5,1.5S29,14,29.8,14s1.5-0.7,1.5-1.5S30.7,11,29.8,11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M25.4,15c-1.4,0-2.5-1.1-2.5-2.5S24,10,25.4,10s2.5,1.1,2.5,2.5S26.8,15,25.4,15z M25.4,11 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S26.2,11,25.4,11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M9,10.5c-0.3,0-0.5-0.2-0.5-0.5V6c0-0.3,0.2-0.5,0.5-0.5S9.5,5.7,9.5,6v4C9.5,10.3,9.3,10.5,9,10.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M25,10.5c-0.3,0-0.5-0.2-0.5-0.5V6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4C25.5,10.3,25.3,10.5,25,10.5z "
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#EC6833",
    cx: "16.5",
    cy: "5.7",
    r: "2.7"
  }));
};

exports["default"] = _default;